import { Component } from '@angular/core';

@Component({
    selector: 'test-video',
    templateUrl: 'test-video.component.html',
    styleUrls: ['test-video.component.scss']
})
export class TestVideoComponent {
}
